import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const FUTURE = ["Study guides","Safety articles","Training handouts","Pre-trip checklists","Driver tips","Downloadable forms","Digital training previews","School bus safety topics","CDL school bus preparation support","English / Spanish materials"];
const TOPICS = ["Why the school bus pre-trip inspection matters","Common mistakes new school bus drivers make","How mirror use prevents accidents","Understanding school bus danger zones","Why tail swing matters","How to stay calm as a new school bus driver","What makes a good school bus driver","Why refresher training matters","How transportation departments can reduce preventable incidents"];

export default function Resources() {
  return (
    <>
      <PageHero
        testid="resources-hero"
        eyebrow="Resources"
        title="Future resources to support drivers, trainers, and districts."
        description="CLB Solution is preparing resources to support school bus driver training, driver safety, and workforce development."
        image={IMAGES.safetyTopics}
      />

      <Section testid="resources-future">
        <SectionTitle eyebrow="Coming Soon" title="Future resource library." />
        <BulletGrid items={FUTURE} testid="resources-future-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="resources-topics">
        <SectionTitle eyebrow="Topics in Development" title="Articles being prepared for release." />
        <ul className="grid md:grid-cols-2 gap-3">
          {TOPICS.map((t, i) => (
            <li key={t} className="border border-white/10 bg-[#09090b] p-5 flex items-start gap-3 hover:border-[#FFCC00]/40 transition-colors">
              <span className="font-mono text-[10px] text-[#FFCC00] mt-1">{String(i + 1).padStart(2, "0")}</span>
              <span className="text-sm md:text-base text-white/85">{t}</span>
            </li>
          ))}
        </ul>
      </Section>

      <CTABand title="Want early access?" description="Reach out and we'll share new resources as they're released." />
    </>
  );
}
